import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import i18n from '@/plugins/vue-i18n'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2E8B57',
        greyDarken: '#212121',
        warningLight: '#FEF0C7',
        warningDark: '#F79009',
        successLight: '#D1FADF',
        successDark: '#039855',
        greenDark: '#69CB69',
        dangerLight: '#FEE4E2',
        dangerDark: '#F04438',
        grayLight: '#F9FAFB'

      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
